export class GAImpressionTracker {
  targetRef: any;
  eventSent: boolean;
  timer: ReturnType<typeof setTimeout>;
  observer: IntersectionObserver;
  options: { threshold: number; timeout: number; rootMargin: string; gaCallback?: () => void };

  constructor(targetRef, observerOptions = {}) {
    this.targetRef = targetRef;
    this.eventSent = false;
    this.timer = null;
    this.observer = null;
    this.options = {
      threshold: 1,
      rootMargin: '0px 0px 0px 0px',
      timeout: 2000,
      ...observerOptions,
    };
  }

  init = () => {
    if (!window.IntersectionObserver) {
      return;
    }

    try {
      const IntersectionObserverConstructor = window.IntersectionObserver;

      this.observer = new IntersectionObserverConstructor(this._observerCallback, {
        threshold: this.options.threshold,
        rootMargin: this.options.rootMargin,
      });

      this.observer.observe(this.targetRef);
    } catch (e) {}
  };

  _observerCallback = entries => {
    if (entries[0].isIntersecting) {
      if (this.timer === null) {
        this.timer = setTimeout(() => {
          if (!this.eventSent && this.options.gaCallback) {
            this.eventSent = true;
            this.options.gaCallback();
          }
          this.timer = null;
        }, this.options.timeout);
      }
    } else {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };
}
